<template>
  <div class="page5 content" style="width:100%;">
    <el-row style="height: 4vh; padding-left: 0.5vw; padding-top: 0.1vh;">
      <el-col :span="24" style="margin:0;">
        <div class="grid-content1 bg-purple-dark" style="float: right;">
          <div>
            <el-button type="warning" size="mini" @click="handleEdit">参数配置</el-button>
            <el-button type="primary" size="mini" @click="goDetail">历史数据统计</el-button>
          </div>
          
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 4vh);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: calc( 100% - 10.5vw );margin-left:0.5vw;">
        <el-card style="height:100% !important;overflow-y: auto;overflow-x: hidden;" class="aside">
          <el-row :gutter="10">
            <el-col :span="8" class="char-vis-pie">
              <el-card class="box-card">
                <div class="month-pie time-up">
                  <span class="el-dropdown-link">天气：{{time}}</span>
                </div>
                <div style="width:100%;height:calc( 100% - 3vh );padding:1vh 1.5vw;top: 3vh;display: flex;align-items: center;">
                  <img :src="weather.now1" style="height:60%;position: relative;top:10px;" />
                  <div style="width:50%;position: relative;padding-left:40px;">
                      <p style="font-size:30px;text-align:left;margin-bottom:20px;">{{weather.now2}}</p>
                      <p style="font-size:30px;text-align:left;">{{weather.now3}}</p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="10" class="char-vis-line">
              <el-card class="box-card">
                <div class="month-pie time-up">
                  <span class="el-dropdown-link">实时监测数据</span>
                  <span class="link-date">更新时间：{{allPart.day}}</span>
                </div>
                <div style="width:100%;height:calc( 100% - 3vh );padding:1vh;top: 6vh;">
                  <el-table :data="valData" border style="width: 100%" :show-header="false">
                    <el-table-column prop="name1" label="姓名"></el-table-column>
                    <el-table-column prop="val1" label="地址">
                        <template slot-scope="scope">
                            <span>{{ scope.row.val1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name2" label="姓名"></el-table-column>
                    <el-table-column prop="val2" label="地址">
                        <template slot-scope="scope">
                            <span>{{ scope.row.val2 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name3" label="姓名"></el-table-column>
                    <el-table-column prop="val3" label="地址">
                        <template slot-scope="scope">
                            <span>{{ scope.row.val3 }}</span>
                        </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-card>
            </el-col>
            <el-col :span="6" class="char-vis-line">
              <el-card class="box-card">
                <div style="width:100%;height:100%;padding:1vh 1.5vw;display:flex;align-items: center;align-content: center;justify-content: center;justify-items: center;flex-wrap:wrap;overflow: hidden;">
                  <img :src="warn.icon" style="height:50%;position: relative;" />
                  <template v-if="warn.list.length>0">
                    <p v-for="(item,index) in warn.list" :key="index" style="width:100%;margin-top:1vh;color:red;">{{item}}预警</p>
                  </template>
                  <template v-else>
                    <p style="width:100%;margin-top:1vh;">暂无预警</p>
                  </template>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24" class="char-vis-line">
              <el-card class="box-card">
                <!-- 环境统计 -->
                <div style="width:100%;text-align: center;display: flex;justify-content: center;">
                  <div class="month-pie time-up">
                    <span class="el-dropdown-link">一周数据统计</span>
                  </div>
                  <div style="width:20vw;height:4vh;border:1px solid #ddd;display: flex;align-content: center;align-items: center;padding:0 0.5vw;">
                    <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="preWeek"><i class="el-icon-arrow-left"></i></div>
                    <p style="flex:1;">
                      <span class="nowrap" :title="weekstart + ' ~ ' +weekEnd" style="display: inline-block;width:100%;">{{weekstart + ' ~ ' +weekEnd}}</span>
                    </p>
                     <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="nextWeek"><i class="el-icon-arrow-right"></i></div>
                  </div>
                </div>
                <div class="echart">
                  <div id="page5Chart3" :style="{ height: '400px',width:'90%' }"></div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-main>
    </el-container>
    <!-- 维护标准窗口 -->
    <el-dialog
        title="参数配置"
        :visible.sync="editFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class='tower-dig'
        class="add-form"
        width="60%"
    >
      <div class="config-con">
        <p class="config-con-item" v-for="(item,index) in configList" :key="index">
          <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
          <span style="display: inline-block;width: 10vw;">单位：（{{item.unit}}）</span>
          <span style="display: inline-block;width: 16vw;">设备预警限位：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
          <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
      </div>
    </el-dialog>
    <!-- 维护PM2.5 优良差窗口 -->
    <el-dialog
        title="PM2.5配置"
        :visible.sync="pm2FormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class='tower-dig'
        class="add-form"
        width="60%"
    >
      <div class="config-con">
        <p class="config-con-item" v-for="(item,index) in pm2List" :key="index">
          <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
          <span style="display: inline-block;width: 10vw;">单位：（{{item.unit}}）</span>
          <span style="display: inline-block;width: 16vw;">{{item.name1}}：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button @click="pm2FormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
          <el-button type="info" @click="setDetfaulePm2">恢复默认值</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts' //引入echarts
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'

export default {
  name: 'eCharts',
  data() {
    return {
      weather:{  //天气
        now1:require('../../assets/image/weather/w0.png'),
        now2:'7° ~ 16°',
        now3:'晴天',
      },
      allPart: {}, // 项目设备数组
      weekstart:'',
      weekEnd:'',
      dustList:[],
      dustId:'',//当前设备id
      time: util.myTime.formatTime(new Date(),'yyyy-MM-dd'),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      groupId: '',
      isDust: false,
      //配置弹出框
      editFormVisible: false, // 弹出框是否显示
      configList:[
        {name:'PM2.5',unit:'μg/m³',val:'75',status:true,default:'75'},
        {name:'PM10',unit:'μg/m³',val:'150',status:true,default:'150'},
        {name:'噪音',unit:'dB',val:'70',status:true,default:'70'},
        {name:'温度',unit:'℃',val:'0',status:true,default:'35'},
        {name:'湿度',unit:'%',val:'0',status:true,default:'60'},
        {name:'风速',unit:'m/s',val:'0',status:true,default:'8'},
      ],
      configData:{
        id:'',
        projectId:'',
        projectName:'',
        noiseSwitch:'1',  //噪音开关   1开  2关
        noise:70,        //噪音
        pm2Switch:'1',    //PM2.5开关   1开  2关
        pm2:'75',          //PM2.5
        pm10Switch:'1',   //PM10开关
        pm10:'150',         //pm10
        temperatureSwitch:'1',  //温度开关
        temperature:0,  //温度
        humiditySwitch:'1',  // 湿度开关
        humidity:0,     //湿度
        windSpeedSwitch:'1', //风速开关
        windSpeed:0,    //风速
        createBy:'1',
        pm25:'',
      },
      hasConf:false,//判断是否已经有配置
      projectName:'',

      warnVal:{pm2Warning:75,pm10Warning:150,noiseWarning:70,temperatureWarning:0,humidityWarning:0,windSpeedWarning:0},
      pm2FormVisible:false,
      pm2List:[
         {name:'PM2.5',unit:'μg/m³',name1:'优',val:'100',status:true,default:'100'},
         {name:'PM2.5',unit:'μg/m³',name1:'良',val:'200',status:true,default:'200'},
      ],
      //数据展示
      valData:[
        {name1:'PM2.5',val1:'',name2:'PM10',val2:'',name3:'TSP',val3:''},
        {name1:'温度',val1:'',name2:'湿度',val2:'',name3:'噪音',val3:''},
        {name1:'风速',val1:'',name2:'风向',val2:'',name3:'气压',val3:''}
      ],
      //预警
      warn:{
        icon:require('../../assets/image/icon/warn.png'),
        list:[]
      },
      //定时器
      timeOutFun:undefined,
    }
  },
  filters: {
    formatDate(value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m
    }
  },
  watch: {
    year: {
      handler(newVal) {
        this.getDataLine()
      },
      deep: true
    },
    month: {
      handler(newVal) {
        this.getDataLine()
      },
      deep: true
    }
  },
  mounted() {
    if (util.session.get('roleId') != '4') {
      this.groupId = util.session.get('proId')
    } else {
      this.groupId = util.session.get('groupId')
    }
    if (this.$route.name == 'dustPro') {
      this.isDust = true
    } else {
      this.isDust = false
    }
    var curWeek = util.myTime.getCurWeek()
    this.weekstart = curWeek[0]
    this.weekEnd = curWeek[1]
    this.getProjectById()
    this.getList()
    // this.getData()
    // this.getDataLine()
    // this.getProjectInfo()
  },
  methods: {
    //获取列表
    getList(){
      var that = this
      myHttp.getListByProjectId({
        projectId:this.groupId
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.dustList || []
          if(list.length>0){
            that.dustId = list[0].id
            that.getData()
            that.getDataLine()
            that.getProjectInfo()
          }
          that.dustList = list
        }
      })
    },
    // 获取数据
    getData() {
      // 扬尘检测
      let that = this
      myHttp.getCurDustInfo({
        projectId:this.groupId,
        id:this.dustId
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.dust
          // data.pm2BL = data.pm2 && data.pm2!=''?parseFloat(data.pm2)/250*100:0
          // data.pm2BL = data.pm2BL>100?100:data.pm2BL
          // data.pm10BL = data.pm10 && data.pm10!=''?parseFloat(data.pm10)/300*100:0
          // data.pm10BL = data.pm10BL>100?100:data.pm10BL
          // data.noiseBL = data.noise && data.noise!=''?parseFloat(data.noise)/120*100:0
          // data.noiseBL = data.noiseBL>100?100:data.noiseBL
          that.valData[0].val1 = data.pm2
          that.valData[0].val2 = data.pm10
          that.valData[0].val3 = data.tspCode
          that.valData[1].val1 = data.temperature
          that.valData[1].val2 = data.humidity
          that.valData[1].val3 = data.noise
          that.valData[2].val1 = data.windSpeed
          that.valData[2].val3 = data.pressureCode
          that.allPart = data
          that.getConfigForWarn()
        }
        if(that.timeOutFun){
          window.clearTimeout(that.timeOutFun)
        }
        that.timeOutFun = setTimeout(()=>{
          that.getData()
        },30000)
      })
      // pm2.5监测
      // myHttp.getPM2ByProjectId({
      //     projectId: this.groupId,
      // }).then(function(resp) {
      //   var data = resp.data.data.pm25
      //   var all =
      //     parseInt(data.cha) + parseInt(data.you) + parseInt(data.liang)
      //   data.all = all
      //   that.setChart4(data)
      // })
    },
    //展示预警
    getConfigForWarn(){
      var that = this
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.list
          if(data){
            var list = []
            var icon = require('../../assets/image/icon/warn.png')
            that.warn.list = []
            for(var i=0;i<that.configList.length;i++){
              if(i==0){
                if(parseFloat(that.allPart.pm2)>parseFloat(data.pm2)){
                  icon = require('../../assets/image/icon/warning.gif')
                  list.push('PM2.5')
                }
              }else if(i==1){
                if(parseFloat(that.allPart.pm10)>parseFloat(data.pm10)){
                  icon = require('../../assets/image/icon/warning.gif')
                  list.push('PM10')
                }
              }else if(i==2){
                if(parseFloat(that.allPart.noise)>parseFloat(data.noise)){
                  icon = require('../../assets/image/icon/warning.gif')
                  list.push('噪音')
                }
              }else if(i==3){
                if(parseFloat(that.allPart.temperature)>parseFloat(data.temperature)){
                  icon = require('../../assets/image/icon/warning.gif')
                  list.push('温度')
                }
              }else if(i==4){
                if(parseFloat(that.allPart.humidity)>parseFloat(data.humidity)){
                  icon = require('../../assets/image/icon/warning.gif')
                  list.push('湿度')
                }
              }else if(i==5){
                if(parseFloat(that.allPart.windSpeed)>parseFloat(data.windSpeed)){
                  icon = require('../../assets/image/icon/warning.gif')
                  list.push('速度')
                }
              }
            }
            that.warn.icon = icon
            that.warn.list = list
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },

    //获取信息
    getProjectInfo(){
      var that = this
      myHttp.getProjectById({
        id:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          that.projectName = resp.data.data.project.name
        }
      })
    },

    /**
     * 获取预警
     */
    // getYijing(){
    //   var that = this
    //   myHttp.selectDustConfig({
    //     projectId:util.session.get('groupId')
    //   }).then(function(resp){
    //     if(resp.data.code=='200'){
    //       var data = resp.data.data
    //       if(data){
    //         // that.hasConf = true
    //         // that.configData = data
    //         // that.setConfigList(data)
    //       }else{
    //         // that.hasConf = false
    //       }
    //     }else{
    //       that.$message.error(resp.data.msg)
    //     }
    //   })
    // },

    getDataLine() {
      // 扬尘检测
      let that = this
      // 最近24小时
      // myHttp.get24HourStatisByProjectId({
      //     projectId: this.groupId,
      //     sn:this.dustId
      // }).then(function(resp) {
      //     var list = resp.data.data.dustList || []
      //     var pm2 = [],
      //       pm10 = [],
      //       noise = [],
      //       temperature = []
      //     for (var i = 0; i < list.length; i++) {
      //       pm2.push(list[i].pm2 || 0)
      //       pm10.push(list[i].pm10 || 0)
      //       noise.push(list[i].noise || 0)
      //       temperature.push(list[i].temperature || 0)
      //     }
      //     var warnVal = JSON.parse(JSON.stringify(that.warnVal))
      //     if(list.length>0){
      //       warnVal.pm2Warning = list[0].pm2Warning || that.warnVal.pm2Warning
      //       warnVal.pm10Warning = list[0].pm10Warning ||that.warnVal.pm10Warning
      //       warnVal.noiseWarning = list[0].noiseWarning ||that.warnVal.noiseWarning
      //       warnVal.temperatureWarning = list[0].temperatureWarning || that.warnVal.temperatureWarning
      //       warnVal.humidityWarning = list[0].humidityWarning || that.warnVal.humidityWarning
      //       warnVal.windSpeedWarning = list[0].windSpeedWarning ||that.warnVal.windSpeedWarning
      //     }
      //     that.setChart2(pm2, pm10, noise, temperature,warnVal)
      // })
      //获取一周数据
      myHttp.getWeekByProjectId({
          projectId: this.groupId,
          startDate: this.weekstart,
          entDate: this.weekEnd,
          sn:this.dustId
      }).then(function(resp) {
          var list2 = resp.data.data.Dust || []
          var pm2 = [],pm2min=[],
            pm10 = [],pm10min=[],
            noise = [],noisemin=[],
            temperature = [],temperaturemin=[]
          for (var i = 0; i < list2.length; i++) {
            pm2.push(list2[i].pm2 || 0)
            pm2min.push(list2[i].pm2Min || 0)
            pm10.push(list2[i].pm10 || 0)
            pm10min.push(list2[i].pm10Min || 0)
            noise.push(list2[i].noise || 0)
            noisemin.push(list2[i].noiseMin || 0)
            temperature.push(list2[i].temperature || 0)
            temperaturemin.push(list2[i].temperatureMin || 0)
          }
          var warnVal = JSON.parse(JSON.stringify(that.warnVal))
          if(list2.length>0){
            warnVal.pm2Warning = list2[0].pm2Warning
            warnVal.pm10Warning = list2[0].pm10Warning
            warnVal.noiseWarning = list2[0].noiseWarning
            warnVal.temperatureWarning = list2[0].temperatureWarning
            warnVal.humidityWarning = list2[0].humidityWarning
            warnVal.windSpeedWarning = list2[0].windSpeedWarning
          }
          that.setChart3(pm2, pm10, noise, temperature,pm2min,pm10min,noisemin,temperaturemin,warnVal)
      })
    },

    // 扬尘检测  eChart2
    setChart2(pm2, pm10, noise, temperature,warnVal) {
      var that = this
      var option = {
        grid: {
          left: '1%',
          right: '1%',
          top: '10%',
          bottom: '5%',
          containLabel: true
        },
        color: ['#29AC5D', '#FF854E', '#892FD5', '#5473E8'],
        legend: {
          show: true,
          icon: 'circle',
          data: ['PM2.5', 'PM10', '噪音(dB)', '温度(℃)'],
          // selectedMode: 'single',
          // top: '-1%',
          right: '5%',
          textStyle: {
            fontSize: 12,
            color: '#666'
          }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
            },
            backgroundColor:'#F3F3F3',
            borderWidth:'1',
            borderColor:'#ABADB2',
            position: function (point, params, dom, rect, size) {
                // 固定在顶部
                return [point[0], '20'];
            },
            formatter(params){
              var content = '<p style="height:40px;color:#707070;font-size:0.9vw;"> '+util.myTime.getCurTime()+' '+params[0].name+'</p>'
              if(parseFloat(params[0].value) < parseFloat(warnVal.pm2Warning)){
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[0].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#67C23A;">'+params[0].value+'μg/m³</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.pm2Warning+'μg/m³)</span></p>'
              }else{
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[0].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">'+params[0].value+'μg/m³</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.pm2Warning+'μg/m³)</span></p>'
              }
              if(parseFloat(params[1].value) < parseFloat(warnVal.pm10Warning)){
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[1].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#67C23A;">'+params[1].value+'μg/m³</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.pm10Warning+'μg/m³)</span></p>'
              }else{
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[1].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">'+params[1].value+'μg/m³</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.pm10Warning+'μg/m³)</span></p>'
              }
              if(parseFloat(params[2].value) < parseFloat(warnVal.noiseWarning)){
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[2].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#67C23A;">'+params[2].value+'dB</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.noiseWarning+'dB)</span></p>'
              }else{
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[2].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">'+params[2].value+'dB</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.noiseWarning+'dB)</span></p>'
              }
              if(parseFloat(params[3].value) < parseFloat(warnVal.temperatureWarning) || parseFloat(that.warnVal.temperatureWarning)==0){
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[3].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#67C23A;">'+params[3].value+'℃</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.temperatureWarning+'℃)</span></p></p>'
              }else{
                content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[3].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">'+params[3].value+'℃</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+warnVal.temperatureWarning+'℃)</span></p></p>'
              }
              
              return content
            }
        },
        xAxis: {
          type: 'category',
          data: [
            '00:00',
            '01:00',
            '02:00',
            '03:00',
            '04:00',
            '05:00',
            '06:00',
            '07:00',
            '08:00',
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00'
          ],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: 1,
            textStyle: {
              color: '#1B3BF5',
              fontWeight: 'Bold'
            }
          }
        },
        yAxis: {
          type: 'value',
          // min: 0,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: 'PM2.5',
            data: pm2,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                }
              }
            },
            smooth: true
          },
          {
            name: 'PM10',
            data: pm10,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                  // color: '#FF854E'
                }
              }
            },
            smooth: true
          },
          {
            name: '噪音(dB)',
            data: noise,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                  // color: '#892FD5'
                }
              }
            },
            smooth: true
          },
          {
            name: '温度(℃)',
            data: temperature,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                  // color: '#5473E8'
                }
              }
            },
            smooth: true
          }
        ]
      }
      var page = this.$echarts.init(document.getElementById('page5Chart2'))
      page.setOption(option)
    },

    // 扬尘检测  eChart3
    setChart3(pm2, pm10, noise, temperature,pm2min,pm10min,noisemin,temperaturemin,warnVal) {
      var date = [this.weekstart]
      var that = this
      for(var i=0;i<5;i++){
        var myDate = new Date(this.weekstart)
        var day = new Date(myDate.getTime() + (i+1) * 24 * 3600 * 1000);
        date.push(util.myTime.formatTime(day,'YYYY-MM-dd'))
      }
      date.push(this.weekEnd)
      var option = {
        grid: {
          left: '1%',
          right: '1%',
          top: '10%',
          bottom: '5%',
          containLabel: true
        },
        color: ['#29AC5D', '#FF854E', '#892FD5', '#5473E8'],
        legend: {
          show: true,
          icon: 'circle',
          data: ['PM2.5', 'PM10', '噪音（dB）', '温度(℃)'],
          // selectedMode: 'single',
          // top: '-1%',
          right: '0%',
          textStyle: {
            fontSize: 12,
            color: '#666'
          }
        },
        // tooltip: {
        //     trigger: 'axis',
        //     axisPointer: {
        //         type: 'cross',
        //         label: {
        //             backgroundColor: '#6a7985',
        //         }
        //     },
        //     textStyle:{
        //       align:'left'
        //     }
        // },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
            },
            backgroundColor:'#F3F3F3',
            borderWidth:'1',
            position: function (point, params, dom, rect, size) {
                // 固定在顶部
                return [point[0], '0'];
            },
            formatter(params){
              var content = '<p style="height:20px;color:#707070;font-size:0.9vw;"> '+params[0].name+'</p>'
              //pm2
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:100px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[0].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[0].value) < parseFloat(warnVal.pm2Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[0].value+'μg/m³</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[0].value+'μg/m³</span></p>'
              }
              if(parseFloat(pm2min[params[0].dataIndex]) < parseFloat(warnVal.pm2Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+pm2min[params[0].dataIndex]+'μg/m³</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+pm2min[params[0].dataIndex]+'μg/m³</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+warnVal.pm2Warning+'μg/m³)</div>'
              +'</div>'
              //pm10
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:100px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[1].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[1].value) < parseFloat(warnVal.pm10Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[1].value+'μg/m³</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[1].value+'μg/m³</span></p>'
              }
              if(parseFloat(pm10min[params[1].dataIndex]) < parseFloat(warnVal.pm10Warning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+pm10min[params[1].dataIndex]+'μg/m³</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+pm10min[params[1].dataIndex]+'μg/m³</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+warnVal.pm10Warning+'μg/m³)</div>'
              +'</div>'
              //噪音
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:100px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[2].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[2].value) < parseFloat(warnVal.noiseWarning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[2].value+'dB</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[2].value+'dB</span></p>'
              }
              if(parseFloat(noisemin[params[2].dataIndex]) < parseFloat(warnVal.noiseWarning)){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+noisemin[params[2].dataIndex]+'dB</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+noisemin[params[2].dataIndex]+'dB</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+warnVal.noiseWarning+'dB)</div>'
              +'</div>'
              // if(parseFloat(params[2].value) < parseFloat(that.warnVal.noiseWarning)){
              //   content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[2].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#67C23A;">'+params[2].value+'dB</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+that.warnVal.noiseWarning+'dB)</span></p>'
              // }else{
              //   content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[2].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">'+params[2].value+'dB</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+that.warnVal.noiseWarning+'dB)</span></p>'
              // }
              //温度
              content += '<div style="height:60px;display:flex;justify-content: flex-start;align-content: center;align-items: center;">'
              +'<div style="width:100px;height:100%;color:#707070;font-size:14px;line-height: 60px;">'+params[3].seriesName+'</div>'
              +'<div style="width:160px;height:100%;border-bottom: 1px solid #ddd;color:#707070;">'
              if(parseFloat(params[3].value) < parseFloat(warnVal.temperatureWarning)||warnVal.temperatureWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#67C23A;">'+params[3].value+'℃</span></p>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最高值：<span style="font-size:14px;color:#F56C6C;">'+params[3].value+'℃</span></p>'
              }
              if(parseFloat(temperaturemin[params[3].dataIndex]) < parseFloat(warnVal.temperatureWarning)||warnVal.temperatureWarning==0){
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#67C23A;">'+temperaturemin[params[3].dataIndex]+'℃</span></p></div>'
              }else{
                content +='<p style="height:30px;width:100%;font-size:14px;line-height: 30px;text-align: left;">最低值：<span style="font-size:14px;color:#F56C6C;">'+temperaturemin[params[3].dataIndex]+'℃</span></p></div>'
              }
              content +='<div style="width:80px;height:100%;color:#707070;font-size:14px;line-height: 60px;color:#F56C6C;text-align: left;">('+warnVal.temperatureWarning+'℃)</div>'
              +'</div>'
              // if(parseFloat(params[3].value) < parseFloat(that.warnVal.temperatureWarning) || parseFloat(that.warnVal.temperatureWarning)==0){
              //   content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[3].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#67C23A;">'+params[3].value+'℃</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+that.warnVal.temperatureWarning+'℃)</span></p></p>'
              // }else{
              //   content +='<p style="text-align: left;height:40px;"><span style="width:80px;display: inline-block;text-align: left;font-size:14px;color:#707070;">'+params[3].seriesName+'</span> <span style="width:120px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">'+params[3].value+'℃</span><span style="width:100px;display: inline-block;text-align: left;font-size:14px;color:#F56C6C;">('+that.warnVal.temperatureWarning+'℃)</span></p></p>'
              // }
              
              return content
            }
        },
        xAxis: {
          type: 'category',
          data: date,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#1B3BF5',
              fontWeight: 'Bold'
            }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: 'PM2.5',
            data: pm2,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                  // color: '#17B2FE'
                }
              }
            },
            // smooth: true
          },
          {
            name: 'PM10',
            data: pm10,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                  // color: '#886CFF'
                }
              }
            },
            // smooth: true
          },
          {
            name: '噪音（dB）',
            data: noise,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                  // color: '#17B2FE'
                }
              }
            },
            // smooth: true
          },
          {
            name: '温度(℃)',
            data: temperature,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 2,
                  // color: '#17B2FE'
                }
              }
            },
            // smooth: true
          }
        ]
      }
      var page = this.$echarts.init(document.getElementById('page5Chart3'))
      page.setOption(option)
    },

    // 扬尘检测  eChart4
    setChart4(data) {
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          z: 2,
          style: {
            text: data.all + '天',
            x: 100,
            y: 100,
            textAlign: 'center',
            fill: '#1B3BF5',
            height: 30,
            fontSize: 22,
            fontWeight: 'bold'
          }
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          data: ['优', '良', '轻度']
        },
        series: [
          {
            name: '环境监测',
            type: 'pie',
            radius: ['55%', '75%'],
            hoverAnimation: false,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ['#6CA2F4', '#78DD7A', '#C3C423']
                  return colorList[params.dataIndex]
                }
              }
            },
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: data.you, name: '优' },
              { value: data.liang, name: '良' },
              { value: data.cha, name: '轻度' }
            ]
          }
        ]
      }
      var page = this.$echarts.init(document.getElementById('page5Chart4'))
      page.setOption(option)
    },
    goDetail(){
      this.$router.push({name:'towerCraneData'})
    },
    //监听周时间
    getWeekFun(data,val){
      console.log(data)
      console.log(val)
    },
    //获取上周时间
    preWeek(){
       var date= util.myTime.getPrevWeek(this.weekstart)
       this.weekstart = date[0]
       this.weekEnd = date[1]
       this.getDataLine()
    },
    //获取下周时间
    nextWeek(){
      var date= util.myTime.getNextWeek(this.weekEnd)
       this.weekstart = date[0]
       this.weekEnd = date[1]
       this.getDataLine()
    },

    // 维护标准
    handleEdit(index, row) {
      this.dialogTitle = '参数配置'
      this.editFormVisible = true
      this.configData.projectId = util.session.get('groupId')
      this.configData.projectName = this.projectName
      var that = this
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.list
          if(data){
            that.hasConf = true
            that.configData = data
            that.setConfigList(data)
          }else{
            that.hasConf = false
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },

    //插入数据
    setConfigList(data){
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configList[i].val = data.pm2
        }else if(i==1){
          this.configList[i].val = data.pm10
        }else if(i==2){
          this.configList[i].val = data.noise
        }else if(i==3){
          this.configList[i].val = data.temperature
        }else if(i==4){
          this.configList[i].val = data.humidity
        }else if(i==5){
          this.configList[i].val = data.windSpeed
        }
      }
      if(data.pm25 && data.pm25!=''){
        var val1 = data.pm25.split(',')
        this.pm2List[0].val = val1[0]
        this.pm2List[1].val = val1[1]
      }
    },

    // 维护环境标准configData
    sumbitEditRow(formName) {
      var that = this
      for(var i=0;i<this.configList.length;i++){
        if(i==0){
          this.configData.pm2 = this.configList[i].val
        }else if(i==1){
          this.configData.pm10 = this.configList[i].val
        }else if(i==2){
          this.configData.noise = this.configList[i].val
        }else if(i==3){
          this.configData.temperature = this.configList[i].val
        }else if(i==4){
          this.configData.humidity = this.configList[i].val
        }else if(i==5){
          this.configData.windSpeed = this.configList[i].val
        }
      }
      this.configData.pm25 = this.pm2List[0].val+','+this.pm2List[1].val
      delete this.configData.createDate
      delete this.configData.updateDate
      this.configData.projectId = this.groupId
      if(this.hasConf){
        this.configData.updateBy = util.session.get('user').id
        myHttp.updateDustConfig(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
            that.pm2FormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }else{
        this.configData.createBy = util.session.get('user').id
        myHttp.addDustConfig(this.configData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('配置成功')
            that.editFormVisible = false
            that.pm2FormVisible = false
          }else{
            that.$message.error(resp.data.msg)
          }
        })
      }
    },
    //设置默认值
    setDetfaule(){
      for(var i=0;i<this.configList.length;i++){
          this.configList[i].val = this.configList[i].default
      }
    },

    //打开pm2.5优良差
    setPm2(){
      this.pm2FormVisible = true
      var that = this
      myHttp.selectDustConfig({
        projectId:util.session.get('groupId')
      }).then(function(resp){
        if(resp.data.code=='200'){
          var data = resp.data.data.list
          if(data){
            that.hasConf = true
            that.configData = data
            that.setConfigList(data)
          }else{
            that.hasConf = false
          }
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },
    //设置pm2.5默认
    setDetfaulePm2(){
      for(var i=0;i<this.pm2List.length;i++){
        this.pm2List[i].val = this.pm2List[i].default
      }
      
    },

    //进入预警记录信息页面
    goWarn(){
      this.$router.push({path:'/dustWarn'})
    },

    /**
     * 切换设备
     */
    changeDevice(row){
      if(row.id != this.dustId){
        this.dustId = row.id
        this.getData()
        this.getDataLine()
        this.getProjectInfo()
      }
    },

    /**
     * 获取天气
     */
    getProjectById(){
        var that = this
        myHttp.getProjectById({
            id: this.groupId
        }).then(function(resp) {
            if (resp.data.code == '200') {
                var data = resp.data.data.project
                that.setAreaFun(data.areaId)
            }
        })
    },
    //获取省市区
    setAreaFun(id){
      if ('' == id || undefined == id) {
          this.getWeather()
          return
      }
      var that = this
      myHttp.getAreaById({
          id: id
      }).then(function(resp) {
          var proCity = ''
          if (resp.data.code == '200') {
              var city = resp.data.data.area.cityName
              var area = resp.data.data.area.name
              proCity = city.indexOf('市')>0?city:area
              
          }
          that.getWeather(proCity)
      },function(error) {})
    },
    //获取天气
    getWeather(city){
      var that = this;
      city = city?city:'合肥市'
      myHttp.getWeather({
          city:city
      }).then(function(resp){
          if(resp.data.code=='200'){
              var info = resp.data.data.data
              that.weather.now1 = that.getSkyIcon(info.forecast[0].type);
              that.weather.now2 = info.forecast[0].low.split(' ')[1] + '~' + info.forecast[0].high.split(' ')[1];
              that.weather.now3 = info.forecast[0].type;
              that.weather.tomorrow = that.getSkyIcon(info.forecast[1].type);
              that.weather.after1 = that.getSkyIcon(info.forecast[2].type);
              that.weather.after2 = that.getSkyIcon(info.forecast[3].type);
              // if(that.dustList[2].val==''||that.dustList[2].val=='--'||that.dustList[2].val=='0'){
              //     that.dustList[2].val = info.forecast[0].fengli.split('[')[2].split(']')[0]
              //     that.dustList[2].name = '风力'
              // }
              that.valData[2].val2 = info.forecast[0].fengxiang
          }
      })
    },
    getSkyIcon(type){
      if(type=='多云'){
          return require('../../assets/image/weather/w1.png');
      }else if(type=='晴天'){
          return require('../../assets/image/weather/w0.png');
      }else if(type=='阴'){
          return require('../../assets/image/weather/w2.png');
      }else if(type.indexOf("雷阵雨")>-1){
          return require('../../assets/image/weather/w4.png');
      }else if(type.indexOf("阵雨")>-1){
          return require('../../assets/image/weather/w3.png');
      }else if(type.indexOf("雨")>-1){
          return require('../../assets/image/weather/w5.png');
      }else if(type.indexOf("雪")>-1){
          return require('../../assets/image/weather/w6.png');
      }else{
          return require('../../assets/image/weather/w1.png');
      }
    },
    

  },
  destroyed(){
    if(this.timeOutFun){
      window.clearTimeout(this.timeOutFun)
    }
  },
}
</script>

<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.grid-content1 {
  /* height: 2.5vh; */
  font-size: 1.6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 4px;
}
.page5 {
  overflow: hidden;
  height: 100%;
}

.page5 .el-row:nth-child(1) .el-col .el-card{
  height:270px;
}
.page5 .el-row:nth-child(2) .el-col .el-card{
  height: 480px;
}

/* .page5 .el-row:last-child {
  margin-bottom: 30px;
} */

.el-col {
  margin-top: 20px;
  border-radius: 4px;
}

.text {
  font-size: 16px;
}

.item {
  padding: 18px 0;
  position: absolute;
  left: 18px;
  top: -10px;
}

.box-card {
  position: relative;
  padding: 10px;
}

.time-up {
  width: 95%;
  display: flex;
  justify-content: space-between;
}

.month-pie,
.month-cir {
  position: absolute;
  /* top: 15px; */
  left: 20px;
  font-size: 18px;
  /* font-weight: bold; */
  color: #707070;
}

.page5 .month-pie span .link-date {
  margin-left: 50px;
  font-size: 15px;
}

/* 年份 */

.year-width {
  width: 80px;
}

.month-cir >>> .el-input__inner {
  border: 0 none;
  height: auto;
  line-height: 20px;
  font-size: 18px;
  padding: 0;
}

.month-cir >>> .el-input__suffix {
  right: 12px;
}

.month-cir >>> .el-input--suffix .el-input__inner {
  padding-right: 0;
  height: auto;
}

.month-cir >>> .el-select .el-input__inner {
  padding-right: 0;
}

.month-cir >>> .el-input__icon {
  height: auto;
  line-height: 20px;
}

/* 月份 */

.month-width {
  position: absolute;
  top: 15px;
  left: 20px;
  width: 60px;
  font-size: 18px;
  font-weight: bold;
  color: #707070;
}

.month-width >>> .el-input__inner {
  border: 0 none;
  height: auto;
  line-height: 20px;
  font-size: 18px;
  padding: 0;
}

.month-width >>> .el-input__suffix {
  right: 12px;
}

.month-width >>> .el-input--suffix .el-input__inner {
  padding-right: 0;
  height: auto;
}

.month-width >>> .el-select .el-input__inner {
  padding-right: 0;
}

.month-width >>> .el-input__icon {
  height: auto;
  line-height: 20px;
}

.page5-cir2 {
  left: 108px;
}

.card-con {
  height: 70px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.card-num {
  width: 60%;
  padding: 18px;
}

.card-num span {
  font-size: 30px;
  color: #1b3bf5;
  font-weight: bold;
}

.card-num img {
  top: -7px;
  position: relative;
}

.color1 span {
  color: #4ecbff;
}

.color2 span {
  color: #ffbc01;
}

.bg-purple {
  position: relative;
  top: 25px;
  left: -3px;
  margin: auto;
  width: 344px;
  height: 280px;
}

.monitor {
  margin-bottom: 44px;
  font-size: 15px;
  text-align: left;
  color: #707070;
}

.monitor-bar1 {
  position: relative;
  width: 100%;
  height: 16px;
  background: #d2cccc;
  overflow: hidden;
  border-radius: 30px;
}

.monitor-bar1 .ul1 {
  display: block;
  width: 100%;
  height: 20px;
}

.monitor-bar1 .ul1 li {
  width: 33.33%;
  height: 20px;
  float: left;
}

.monitor-bar1 .ul2 li {
  width: 33.3333%;
  height: 20px;
  float: left;
}

.abr-num,
.abr2-num {
  position: relative;
  bottom: -10px;
}

.abr-num li,
.abr2-num li {
  float: left;
  text-align: center;
}

.abr-num li:nth-child(2) {
  margin-left: 55px;
}

.abr-num li:nth-child(3) {
  margin-left: 53px;
}

.abr-num li:nth-child(4) {
  margin-left: 48px;
}

.abr-num li:nth-child(5) {
  margin-left: 48px;
}

.abr-num li:nth-child(6) {
  position: relative;
  right: -47px;
}

.abr-num li span,
.abr2-num li span {
  color: #1b3bf5;
  font-size: 12px;
}

.abr-num li p,
.abr2-num li p {
  color: #707070;
  font-size: 12px;
}

.abr2-num li:nth-child(2) {
  margin-left: 101px;
}

.abr2-num li:nth-child(3) {
  margin-left: 98px;
}

.abr2-num li:nth-child(4) {
  position: relative;
  right: -92px;
}

.monitor-box,
.monitor-box2 {
  position: absolute;
  /* left: -20px; */
  /* width: 46px;
  height: 46px;
  line-height: 55px;
  font-size: 13px;
  text-align: center;
  color: #1b3bf5;
  background: url(../../assets/image/water.png) no-repeat;
  background-size: cover; */
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 20px solid red;
}

/* 1.14X32 */

/* box1 200 */
.monitor-box {
  position: absolute;
  /* left: 73.5%; */
}

/* box1 300, box2 150 */
.monitor-box,
.monitor-box2 {
  position: absolute;
  /* left: 320px; */
}

.page5-tu2 {
  margin-top: 15px;
}

.page5-tu4 {
  margin-top: 5px;
  margin-left: -85px;
}
.build-bar .btnLef {
  position: absolute;
  right: 6%;
  display: block;
  width: 95px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 4px;
  background: #ffaf15;
  border: 1px solid #ffb800;
}

.main-left{
    width: 10vw;
    height: 100%;
    position: relative;
    padding: 1vh 0.6vh;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    background: #fff;
    align-content: flex-start;
}
.main-left-item{
    height: 7vh;
    width: 100%;
    position: relative;
    background: #E7F1FB;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    padding: 0.5vh;
    cursor: pointer;
    margin-top: 1vh;
}
.main-left-item p{
    height: 3vh;
    position: relative;
    text-align: left;
    display: flex;
    align-content: center;
    align-items: center;
}
.main-left-item .name{
    width: calc( 100% - 3vw );
    position: relative;
}
.main-left-item .state{
    width: 3vw;
    position: relative;
    justify-content: flex-end;
}
.main-left-item .num{
    width: 100%;
    position: relative;
}
.curTower{
    background: #1E369A;
}
.curTower .name,.curTower .state,.curTower .num{
    color: #fff;
}
</style>
<style>
  @import '../../assets/css/common.css';
  .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
</style>